
export default {
    name: 'SiteSteps',
    props: {
        /**
         * The active step
         */
        active: {
            type: String,
            required: true,
        },
        /**
         * An array of steps
         */
        steps: {
            type: Array,
            required: true,
        },
    },
    computed: {
        currentIndex() {
            let currentIndex;
            this.steps.forEach((step, index) => {
                if (step.name === this.active) {
                    currentIndex = index;
                }
            });
            return currentIndex;
        },
    },
};
